<template>
  <div class="flex align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-6 md:w-6 lg:w-5 xl:w-4">
      <template #title>KATEGÓRIA</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="categoryForm">
            <div class="field">
                <label for="category-name">Názov</label>
                <InputText class="w-full" 
                  :class="`${v$.category.name.$error ? 'bg-red-200' : ''}`"
                  :invalid="v$.category.name.$error"
                  v-model="this.category.name"
                  type="text"
                  name="category-name"
                  id="category-name"
                >
                </InputText>
                <div
                     v-for="(error, index) of v$.category.name.$errors"
                     :key="index"
                     class="text-sm font-italic text-red-400"
                >
                  {{ error.$message }}
                </div>
            </div>

            <div class="field">
              <label for="description">Popis</label>
              <PrimevueTextArea autoResize rows="4" class="w-full"
                placeholder="Tu napíš popis ku kategórii"
                v-model="this.category.description"
                style="text-align: left"
                name="description"
                id="description"
                >
              </PrimevueTextArea>
            </div>

            
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link to="/mod-stock/categories">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    
    </PrimevueCard>
  </div>

</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
//import PrimevuePassword from 'primevue/password';
//import PrimevueCheckbox from 'primevue/checkbox';
import PrimevueButton from 'primevue/button';
import PrimevueTextArea from "primevue/textarea";
import PrimevueCard from 'primevue/card';
import { required, helpers, minLength  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

//const mustBe421 = (value : string) => !helpers.req(value) || value.startsWith('+421')

export default {
  name: "CategoryEdit",
  components: {
      //PrimevuePassword,
      //PrimevueCheckbox,
      PrimevueButton,
      PrimevueTextArea,
      PrimevueCard,
  },
  data() {
    return {
      store,
      //dialogClosedByAccept: false,
      //departOptions: [],
      category: {
        id: 0,
        name: "",
        description: "",
      },

    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      category: {
        name: { required: helpers.withMessage('Názov nesmie byť prázdny', required),
                minLength: helpers.withMessage('Názov musí obsahovať min. 2 znaky', minLength(2)),
              },

      }
    }
  },
  methods: {
    async submitHandler() {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return
      }

      const categoryId = parseInt(String(this.$route.params.categoryId), 10)
      //console.log('userId:', userId)
      //let depart = this.departOptions.filter(obj => obj.id == this.user.department)[0]  
      //console.log('Depart:', depart)
      const payload = {
        id: this.category.id,
        name: this.category.name,
        description: this.category.description,
        deleted: false
      }

      let method = "POST"
      let url = "/v1/category/"
      if (categoryId > 0){
        method = "PUT"
        url = "/v1/category/" + categoryId
      }

      fetch(store.Api_url + url, Security.requestOptions(method, payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              console.log("error:", responseData.data.message);
              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Kategória bola uložená"
              })
              this.category = responseData.data
              router.push("/mod-stock/categories");
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení kategórie" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení kategórie" + error
            })
          })


    },
    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
      //this.isPhoneValid = this.user.phone.startsWith('+421');
      //if(this.isPhoneValid) {
      //  return true
      //}else{
      //  return false
      //}
    },

  },

  beforeMount() {
    //console.log("calling user")
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      //if(store.user.admin===false ){
      //  router.push("/")
      //  notie.alert({
      //    type: 'error',
      //    text: "Na túto akciu nemáte oprávnenia"
      //  })
      

      if (parseInt(String(this.$route.params.categoryId), 10) > 0) {
        // editing an existing user
        const categoryId = String(this.$route.params.categoryId)

        fetch(store.Api_url + "/v1/category/" + categoryId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.data);
                //this.$emit('error', responseData.data);
              } else {
                //console.log(responseData);
                this.category = responseData.data

              }
            })
            .catch((error) => {
              this.$emit('error', "Chyba pri načítaní kategórií" + error);
        })
      }


    }

  }
}
</script>



<style scoped>

</style>